













































import Vue from 'vue';
import * as actions from '@/store/action-types';
import StatsService from '@/api/stats.service';
import { IEventRollup, IReactivationStats } from '@/store/types';
import { LOAD_STATE } from '@/store/shared';
import { mapGetters } from 'vuex';
import { descending, min } from 'd3-array';
import { shortMonthYearLabel } from '@/helpers/date-utils';
import BarLoader from '@/components/UI/Loader/BarLoader.vue';
import FooterLoader from '@/components/UI/Loader/FooterLoader.vue';
import HeaderLoader from '@/components/UI/Loader/HeaderLoader.vue';
import DateHeatmap from '@/components/Vis/D3/Charts/DateHeatmap';
// import 'cal-heatmap/dist/cal-heatmap.css';

export default Vue.extend({
  name: 'CustomerActivity',
  components: {
    BarLoader,
    HeaderLoader,
    FooterLoader,
  },
  data() {
    return {
      LOAD_STATE,
      localReactivationStats: [] as IReactivationStats[],
      localReactivationStatsLoadState: LOAD_STATE.UNLOADED,
      heatmap: null as null | DateHeatmap,
    };
  },
  async created() {
    this.$store.dispatch(actions.FETCH_EVENT_ROLLUP, { filter: { bucket: 'day' } });
  },
  computed: {
    ...mapGetters([]),
    loading(): boolean {
      return this.$store.state.eventRollupLoadState !== LOAD_STATE.LOADED;
    },
    stats(): IEventRollup[] {
      return this.$store.state.eventRollup;
    },
  },
  watch: {
    stats() {
      if (this.stats) {
        this.drawHeatmap();
      }
    },
  },
  mounted() {
    this.drawHeatmap();
  },
  methods: {
    drawHeatmap(): void {
      if (!this.stats) {
        return;
      }

      // use CalHeatMap to draw heatmap
      if (!this.heatmap) {
        // set start date to beginning of this year and end date to end of year
        const minDate = new Date();
        minDate.setMonth(0);
        minDate.setDate(1);
        const maxDate = new Date();
        maxDate.setMonth(11);
        maxDate.setDate(31);
        this.heatmap = new DateHeatmap({
          target: '#cal-heatmap-container',
          minDate,
          maxDate,
        });
      }

      this.heatmap.render({
        data: this.stats.map((d) => ({
          ...d,
          count: d.customerCount,
        })),
      });
    },
    exportData() {
      const sortedData = this.stats
        .map((d) => ({
          ...d,
        }))
        .sort((a, b) => descending(a.date, b.date));
      this.$store.dispatch(actions.EXPORT_DATA, {
        data: sortedData,
        name: 'event-counts',
        csv: true,
      });
    },
  },
});
